import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;
}

export function pushPermission() {
  if (typeof Notification === "undefined") return "default";
  return Notification.permission; // "default" | "granted" | "denied"
}

async function ensureRegistration() {
  let reg = await navigator.serviceWorker.getRegistration();
  if (!reg) {
    reg = await navigator.serviceWorker.register("/sw.js");
  }
  await navigator.serviceWorker.ready;
  return reg;
}

export async function isPushSubscribed() {
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return false;
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push not supported in this browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    throw new Error(perm === "denied" ? "Notifications blocked — enable them in your browser settings" : "Permission required");
  }
  const reg = await ensureRegistration();
  // Fetch VAPID key
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.public_key) throw new Error("Push not configured on server");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: subJson.endpoint,
    keys: subJson.keys,
    expirationTime: subJson.expirationTime ?? null,
  });
  return true;
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return false;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return false;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  try { await api.post("/push/unsubscribe", { endpoint }); } catch (e) { /* ignore */ }
  return true;
}
